import validate from "/build/node_modules/nuxt/dist/pages/runtime/validate.js";
import check_45auth_45global from "/build/src/middleware/checkAuth.global.js";
import manifest_45route_45rule from "/build/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  check_45auth_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}